import { meta } from '@/helpers/constants/router';
import { PRODUCTS_ROUTE, CATEGORIES_ROUTE, CATEGORIES_NEW_ROUTE, CATEGORIES_EDIT_ROUTE, CATEGORIES_DETAILS_ROUTE, PRODUCTS_NEW_ROUTE, PRODUCTS_DETAILS_ROUTE, PRODUCTS_EDIT_ROUTE, OVERVIEW_ROUTE, OVERVIEW_PRODUCTS_ROUTE, OVERVIEW_SALES_ROUTE, OVERVIEW_CUSTOMERS_ROUTE, PERFORMANCE_ROUTE, PERFORMANCE_POPULAR_PRODUCTS_ROUTE, PERFORMANCE_PROFITABLE_PRODUCTS_ROUTE, ADDONS_ROUTE, ADDONS_NEW_ROUTE, ADDONS_EDIT_ROUTE, ORDERS_ROUTE, ORDERS_HISTORY_ROUTE, STORE_ROUTE, STORE_EDIT_ROUTE, PAYMENT_ROUTE, SHIPPING_ROUTE, SHIPPING_EDIT_ROUTE, SHIPPING_NEW_ROUTE, MERCHANT_REGISTRATION, } from '@/helpers/constants/StoreManagerRoutes';
import { REBATES_REDEEMED_VOUCHERS_ROUTE, REBATES_VOUCHERS_REDEMPTION_ROUTE, } from '@/helpers/constants/StoreAddOnsRoutes';
import { ECOMMERCE_MARKETING_MENU_KEY } from '@/helpers/constants/app';
// lazy load components
// https://router.vuejs.org/guide/advanced/lazy-loading.html
const Products = () => import('@/views/v2/ecommerce/Products.vue');
const Categories = () => import('@/views/v2/ecommerce/Categories.vue');
const Wrapper = () => import('@/views/Wrapper.vue');
const Referrals = () => import('@/views/v2/Referrals.vue');
const ReferralList = () => import('@/components/v2/ReferralLinks.vue');
const SmartRetailLinks = () => import('@/components/v2/SmartRetailLinks.vue');
export default [
    {
        path: 'store-manager',
        component: Wrapper,
        meta: { ...meta, title: 'Store Manager' },
        children: [
            {
                path: 'products',
                component: Wrapper,
                redirect: PRODUCTS_ROUTE.name,
                meta: { ...meta, title: PRODUCTS_ROUTE.title },
                children: [
                    {
                        path: ':componentUUID',
                        component: Wrapper,
                        children: [
                            {
                                path: 'categories',
                                component: Wrapper,
                                meta,
                                children: [
                                    {
                                        path: '/',
                                        name: CATEGORIES_ROUTE.name,
                                        component: Categories,
                                        meta: {
                                            title: CATEGORIES_ROUTE.title,
                                            subtitle: 'Customize your categories. Drag and drop to arrange category sequence',
                                            parentMenu: PRODUCTS_ROUTE.name,
                                        },
                                    },
                                    {
                                        path: 'create',
                                        name: CATEGORIES_NEW_ROUTE.name,
                                        component: () => import('@/views/v2/ecommerce/CategoryCreate.vue'),
                                        meta: {
                                            title: CATEGORIES_NEW_ROUTE.title,
                                            parentMenu: PRODUCTS_ROUTE.name,
                                        },
                                    },
                                    {
                                        path: ':uuid',
                                        meta: { title: 'Categories' },
                                        component: Wrapper,
                                        children: [
                                            {
                                                path: 'edit',
                                                name: CATEGORIES_EDIT_ROUTE.name,
                                                component: () => import('@/views/v2/ecommerce/CategoryUpdate.vue'),
                                                props: true,
                                                meta: {
                                                    title: CATEGORIES_EDIT_ROUTE.title,
                                                    parentMenu: PRODUCTS_ROUTE.name,
                                                },
                                            },
                                            {
                                                path: 'details',
                                                name: CATEGORIES_DETAILS_ROUTE.name,
                                                component: () => import('@/views/v2/ecommerce/CategoryDetails.vue'),
                                                props: true,
                                                meta: {
                                                    title: CATEGORIES_DETAILS_ROUTE.title,
                                                    parentMenu: PRODUCTS_ROUTE.name,
                                                },
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                path: '/',
                                name: PRODUCTS_ROUTE.name,
                                component: Products,
                                meta: {
                                    title: PRODUCTS_ROUTE.title,
                                    parentMenu: PRODUCTS_ROUTE.name,
                                    subtitle: 'Customize product information such as product description, price and variances.',
                                },
                            },
                            {
                                path: 'create',
                                name: PRODUCTS_NEW_ROUTE.name,
                                component: () => import('@/views/v2/ecommerce/ProductsCreate.vue'),
                                meta: {
                                    title: PRODUCTS_NEW_ROUTE.title,
                                    parentMenu: PRODUCTS_ROUTE.name,
                                },
                            },
                            {
                                path: ':uuid',
                                component: Wrapper,
                                children: [
                                    {
                                        path: '/',
                                        name: PRODUCTS_DETAILS_ROUTE.name,
                                        component: () => import('@/views/v2/ecommerce/ProductDetails.vue'),
                                        props: true,
                                        meta: {
                                            title: PRODUCTS_DETAILS_ROUTE.title,
                                            parentMenu: PRODUCTS_ROUTE.name,
                                        },
                                    },
                                    {
                                        path: 'edit',
                                        name: PRODUCTS_EDIT_ROUTE.name,
                                        component: () => import('@/views/v2/ecommerce/ProductsEdit.vue'),
                                        props: true,
                                        meta: {
                                            title: PRODUCTS_EDIT_ROUTE.title,
                                            parentMenu: PRODUCTS_ROUTE.name,
                                        },
                                    },
                                ],
                            },
                        ],
                    },
                ],
            },
            {
                path: 'overview',
                component: Wrapper,
                meta: { ...meta, title: OVERVIEW_ROUTE.title },
                children: [
                    {
                        path: '/',
                        component: Wrapper,
                        meta: {
                            title: 'Overview',
                            redirect: OVERVIEW_ROUTE.name,
                        },
                        children: [
                            {
                                path: '/',
                                name: OVERVIEW_ROUTE.name,
                                component: () => import('@/views/v2/ecommerce/Overview.vue'),
                                meta: {
                                    title: OVERVIEW_ROUTE.title,
                                },
                            },
                            {
                                path: 'latest-sold-products',
                                name: OVERVIEW_PRODUCTS_ROUTE.name,
                                component: () => import('@/components/v2/ecommerce/LatestSoldProductsIndex.vue'),
                                meta: { title: OVERVIEW_PRODUCTS_ROUTE.title },
                            },
                            {
                                path: 'sales-amount',
                                name: OVERVIEW_SALES_ROUTE.name,
                                component: () => import('@/components/v2/ecommerce/SalesAmountIndex.vue'),
                                meta: { title: OVERVIEW_SALES_ROUTE.title },
                            },
                            {
                                path: 'latest-customers',
                                name: OVERVIEW_CUSTOMERS_ROUTE.name,
                                component: () => import('@/components/v2/ecommerce/LatestCustomersIndex.vue'),
                                meta: { title: OVERVIEW_CUSTOMERS_ROUTE.title },
                            },
                        ],
                    },
                    {
                        path: 'performance',
                        component: Wrapper,
                        meta: {
                            title: PERFORMANCE_ROUTE.title,
                            redirect: PERFORMANCE_ROUTE.name,
                        },
                        children: [
                            {
                                path: '/',
                                name: PERFORMANCE_ROUTE.name,
                                component: () => import('@/views/v2/ecommerce/Performance.vue'),
                                meta: {
                                    title: PERFORMANCE_ROUTE.title,
                                },
                            },
                            {
                                path: 'popular-producs',
                                name: PERFORMANCE_POPULAR_PRODUCTS_ROUTE.name,
                                component: () => import('@/views/v2/ecommerce/PopularProductList.vue'),
                                meta: {
                                    title: PERFORMANCE_POPULAR_PRODUCTS_ROUTE.title,
                                    parentMenu: PERFORMANCE_ROUTE.name,
                                },
                            },
                            {
                                path: 'most-sold-producs',
                                name: PERFORMANCE_PROFITABLE_PRODUCTS_ROUTE.name,
                                component: () => import('@/views/v2/ecommerce/ProfitableProductList.vue'),
                                meta: {
                                    title: PERFORMANCE_PROFITABLE_PRODUCTS_ROUTE.title,
                                    parentMenu: PERFORMANCE_ROUTE.name,
                                },
                            },
                        ],
                    },
                ],
            },
            {
                path: 'add-ons',
                component: Wrapper,
                redirect: ADDONS_ROUTE.name,
                meta: { ...meta, title: ADDONS_ROUTE.title },
                children: [
                    {
                        path: '/',
                        name: ADDONS_ROUTE.name,
                        meta: {
                            title: ADDONS_ROUTE.title,
                            subtitle: 'Upsell your other services like gift wrapping, additional box and etc.',
                        },
                        component: () => import('@/views/v2/apps/CartAddOns.vue'),
                    },
                    {
                        path: 'create',
                        name: ADDONS_NEW_ROUTE.name,
                        component: () => import('@/views/v2/apps/CartAddOnsCreate.vue'),
                        meta: { title: ADDONS_NEW_ROUTE.title },
                    },
                    {
                        path: ':uuid',
                        component: Wrapper,
                        meta,
                        children: [
                            {
                                path: 'edit',
                                name: ADDONS_EDIT_ROUTE.name,
                                props: true,
                                component: () => import('@/views/v2/apps/CartAddOnsEdit.vue'),
                                meta: { title: ADDONS_EDIT_ROUTE.title },
                            },
                        ],
                    },
                ],
            },
            {
                path: 'orders',
                component: Wrapper,
                redirect: ORDERS_ROUTE.name,
                meta: { ...meta, title: 'Orders' },
                children: [
                    {
                        path: 'history',
                        name: ORDERS_HISTORY_ROUTE.name,
                        meta: { title: ORDERS_HISTORY_ROUTE.title },
                        props: true,
                        component: () => import('@/views/v2/ecommerce/OrderHistory.vue'),
                    },
                    {
                        path: ':status/:filter?',
                        component: () => import('@/views/v2/ecommerce/Orders.vue'),
                        children: [
                            {
                                path: '/',
                                name: ORDERS_ROUTE.name,
                                meta: { title: ORDERS_ROUTE.title },
                                props: true,
                                component: () => import('@/views/v2/ecommerce/OrdersByStatus.vue'),
                            },
                        ],
                    },
                ],
            },
            {
                path: 'rebates',
                component: Wrapper,
                meta: { ...meta, title: REBATES_REDEEMED_VOUCHERS_ROUTE.title },
                children: [
                    {
                        path: '/',
                        name: 'redeemed-vouchers',
                        meta: { title: REBATES_REDEEMED_VOUCHERS_ROUTE.title },
                        component: () => import('@/views/v2/store_add_ons/rebates/RedeemableVouchers.vue'),
                    },
                    {
                        path: 'create',
                        name: REBATES_VOUCHERS_REDEMPTION_ROUTE.name,
                        component: () => import('@/views/v2/store_add_ons/rebates/RedeemVoucherPage.vue'),
                        meta: { title: REBATES_VOUCHERS_REDEMPTION_ROUTE.title },
                    },
                ],
            },
            {
                path: 'store-details',
                component: Wrapper,
                redirect: STORE_ROUTE.name,
                meta: { ...meta, title: STORE_ROUTE.title },
                children: [
                    {
                        path: '/',
                        name: STORE_ROUTE.name,
                        meta: {
                            title: STORE_ROUTE.title,
                        },
                        component: () => import('@/views/v2/store_manager/StoreDetails.vue'),
                    },
                    {
                        path: ':uuid',
                        meta: { title: STORE_ROUTE.title },
                        component: Wrapper,
                        children: [
                            {
                                path: 'edit',
                                name: STORE_EDIT_ROUTE.name,
                                component: () => import('@/views/v2/store_manager/StoreDetailsEdit.vue'),
                                props: true,
                                meta: {
                                    title: STORE_EDIT_ROUTE.title,
                                },
                            },
                        ],
                    },
                ],
            },
            {
                path: 'shipping-methods',
                component: Wrapper,
                redirect: SHIPPING_ROUTE.name,
                meta: { ...meta, title: SHIPPING_ROUTE.title },
                children: [
                    {
                        path: '/',
                        name: SHIPPING_ROUTE.name,
                        component: () => import('@/views/v2/apps/ShippingMethods.vue'),
                        meta: { title: SHIPPING_ROUTE.title, subtitle: 'Manage your shipping methods' },
                    },
                    {
                        path: 'create',
                        name: SHIPPING_NEW_ROUTE.name,
                        component: () => import('@/views/v2/apps/ShippingMethodsCreate.vue'),
                        meta: { title: SHIPPING_NEW_ROUTE.title },
                    },
                    {
                        path: ':uuid',
                        component: Wrapper,
                        meta,
                        children: [
                            {
                                path: 'edit',
                                name: SHIPPING_EDIT_ROUTE.name,
                                props: true,
                                component: () => import('@/views/v2/apps/ShippingMethodsEdit.vue'),
                                meta: { title: SHIPPING_EDIT_ROUTE.title },
                            },
                        ],
                    },
                ],
            },
            {
                path: 'payment',
                redirect: PAYMENT_ROUTE.name,
                component: Wrapper,
                meta: { ...meta, title: PAYMENT_ROUTE.title },
                children: [
                    {
                        path: '/',
                        name: PAYMENT_ROUTE.name,
                        component: () => import('@/views/v2/Payments.vue'),
                        meta: {
                            title: PAYMENT_ROUTE.title,
                            subtitle: 'Manage your payment options',
                        },
                    },
                    {
                        path: 'merchant',
                        name: MERCHANT_REGISTRATION.name,
                        component: () => import('@/views/v2/MerchantPaymentRegistration.vue'),
                        meta: {
                            title: MERCHANT_REGISTRATION.title,
                            subtitle: '',
                        },
                    },
                ],
            },
            {
                path: 'referrals',
                component: Wrapper,
                meta: { ...meta, title: 'Referrals' },
                children: [
                    {
                        path: '',
                        component: Referrals,
                        meta: { ...meta, title: 'Referrals' },
                        children: [
                            {
                                path: '/',
                                name: 'store-manager-referral',
                                meta: {
                                    title: 'Referrals',
                                    redirect: 'store-manager-referral',
                                    parentMenu: ECOMMERCE_MARKETING_MENU_KEY,
                                },
                                component: ReferralList,
                            },
                            {
                                path: 'smart-retail-links',
                                component: Wrapper,
                                meta: { ...meta, title: 'Referrals' },
                                children: [
                                    {
                                        path: '/',
                                        name: 'store-manager-smart-retail',
                                        meta: {
                                            title: 'Smart Retail Links',
                                            redirect: 'store-manager-smart-retail',
                                            parentMenu: ECOMMERCE_MARKETING_MENU_KEY,
                                        },
                                        component: SmartRetailLinks,
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        path: ':referralLinkUuid',
                        component: Wrapper,
                        meta,
                        children: [
                            {
                                path: 'details',
                                name: 'store-manager-referral-details',
                                meta: { title: 'Referral Details', parentMenu: ECOMMERCE_MARKETING_MENU_KEY },
                                component: () => import('@/views/v2/ReferralDetails.vue'),
                                props: true,
                            },
                        ],
                    },
                ],
            },
            {
                path: 'notifications',
                name: 'store-manager-notifications',
                component: () => import('@/views/v2/NotificationsManager.vue'),
                meta: { ...meta, title: 'Notification Manager' },
                redirect: { name: 'store-manager-notifications-manager-email' },
                children: [
                    {
                        path: 'fb-messenger',
                        name: 'store-manager-notifications-manager-fb-messenger',
                        meta: { title: 'Notification Manager', parentMenu: 'store-manager-notifications' },
                        component: () => import('@/views/v2/NotificationsFbMessenger.vue'),
                    },
                    {
                        path: 'email',
                        name: 'store-manager-notifications-manager-email',
                        meta: { title: 'Notification Manager', parentMenu: 'store-manager-notifications' },
                        component: () => import('@/views/v2/NotificationsEmail.vue'),
                    },
                ],
            },
        ],
    },
];
